/* eslint-disable react-hooks/exhaustive-deps */
import { Space, Tag, Typography } from "antd";
import CustomTextHiddenLine from "components/CustomTextHiddenLine";
import { renderInvitedStatus } from "features/Agent/List/AgentTab/useAgentTab";
import { useGetSeller } from "hooks/seller";
import useDebounce from "hooks/useDebounce";
import { t } from "i18next";
import { compact, isNil } from "lodash";
import { FilterInvited, FilterStatus } from "pages/App/Agent/List/components/FilterSeller";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getQuery } from "utils/helperFuncs";
import { omit } from "utils/object";

function useAgentPickerModal() {
  const GET_QUERY = getQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedValue = useDebounce(searchTerm, 500);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isFilterSelected, setIsFilterSelected] = useState(false);

  const countSelectedRowKeys = selectedRowKeys?.length ? selectedRowKeys?.length : 0;
  const [params, setParams] = useState({
    filters: {
      statuses: GET_QUERY.statuses || undefined,
      query: GET_QUERY.query || undefined,
    },
    pagination: {
      offset: GET_QUERY.offset || 0,
      limit: GET_QUERY.limit || 10,
    },
  });

  const {
    loading,
    data: dataSeller,
    paginationData,
  } = useGetSeller({
    ...params,
    filters: {
      ...omit(params?.filters, ["periodSelected", "statuses"]),
      approvalStatus: "APPROVED",
    },
  });

  const filterItemsTypeOptions = [
    { label: t("common.all"), value: false },
    { label: `${t("cart.selected")} (${countSelectedRowKeys})`, value: true },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
    selectedRowKeys: selectedRowKeys,
    preserveSelectedRowKeys: true,
  };

  // check type table

  // handle
  const handleChange = (e) => {
    const newValue = e.target.value;
    setIsFilterSelected(newValue);
    // Clear search query khi chuyển sang tab "Đã chọn"
    if (newValue) {
      // Tab "Đã chọn" được chọn, clear search query
      setSearchTerm("");
      setParams({
        ...params,
        filters: {
          ...params.filters,
          query: undefined,
        },
        pagination: {
          ...params.pagination,
          offset: 0,
        },
      });
    }
  };

  const handleFilterSellerExtra = (values) => {
    const newParams = { ...params, filters: { ...params.filters, ...values } };
    setParams(newParams);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    setParams({
      ...params,
      filters: {
        ...params.filters,
        query: debouncedValue?.trim(),
      },
      pagination: {
        ...params.pagination,
        offset: 0,
      },
    });
  }, [debouncedValue]);

  const onTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;

    let newParams = {
      ...params,
      pagination: { ...params.pagination, offset: (current - 1) * pageSize },
    };
    setParams(newParams);
  };

  const handleCloseTag = (key) => {
    const newParams = { ...params, filters: omit(params.filters, key) };
    setParams(newParams);
  };

  const columns = [
    {
      title: "ĐẠI LÝ",
      width: 320,
      render: (text, record, index) => {
        return (
          <Space direction="vertical">
            <Typography.Text strong>
              <CustomTextHiddenLine
                line={1}
                isLink
                text={
                  <Link target="_blank" rel="noreferrer" to={`seller/detail/${record?.id}`}>
                    {record?.code}
                  </Link>
                }
              />
            </Typography.Text>
            <CustomTextHiddenLine line={2} text={record?.fullName} />
          </Space>
        );
      },
    },
    {
      title: t("common.address"),
      width: 300,
      render: (text, record, index) => {
        return (
          <CustomTextHiddenLine
            line={2}
            text={compact([record?.address, record?.ward?.name, record?.district?.name, record?.city?.name]).join(", ")}
          />
        );
      },
    },
    {
      title: "SỐ DƯ NỢ",
      align: "center",
      width: 100,
      render: (text, record, index) => {
        return record?.currentDebt ?? 0;
      },
    },
    {
      title: "SỐ LƯỢNG ĐƠN HOÀN THÀNH",
      width: 180,
      align: "center",
      render: (_, record, index) => {
        return record?.totalOrderDelivery?.totalWaiting + record?.totalOrderDelivery?.totalDelivering || 0;
      },
    },
    {
      title: "ĐÃ DÙNG APP",
      align: "center",
      render: (text, record, index) => renderInvitedStatus(record?.isLoggedIn, record?.countInvite, record?.isActive),
      filterDropdown: !isFilterSelected && <FilterInvited onFilter={handleFilterSellerExtra} />,
    },
    {
      title: "TRẠNG THÁI",
      align: "center",
      render: (text, record, index) => {
        return record.isActive ? (
          <Tag key={index} className="custom-tag-stock-product-available-ha">
            Đang hợp tác
          </Tag>
        ) : (
          <Tag key={index} className="custom-tag-stock-product-out-of-stock">
            Ngưng hợp tác
          </Tag>
        );
      },
      filterDropdown: !isFilterSelected && <FilterStatus onFilter={handleFilterSellerExtra} />,
    },
  ];

  useEffect(() => {
    if (!isNil(debouncedValue)) {
      const newParams = {
        ...params,
        filters: { ...params?.filters, query: debouncedValue.trim() || undefined },
        pagination: {
          offset: 0,
          limit: 10,
        },
      };
      setParams(newParams);
    }
  }, [debouncedValue]);

  return {
    filterItemsTypeOptions,
    rowSelection,
    loading,
    columns,
    isFilterSelected,
    setIsFilterSelected,
    selectedRows,
    dataSeller,
    paginationData,
    handleSearch,
    handleChange,
    onTableChange,
    handleCloseTag,
    params,
  };
}

export default useAgentPickerModal;
